import * as appHelper from './appHelper';
import * as objectConstants from '../constants/objectConstants';
import * as objectModels from '../models/objectModels';
import * as assetConstants from '../constants/assetConstants';
const NONE = "none";

export function getScreenAssetPanelWidth(screen) {
    let style = "";
    if (showAssetLeftPanel(screen) || showAssetRightPanel(screen)){
        style = "flexi";
    }

    return style;
}

export function showAssetLeftPanel(screen) {
    return appHelper.isDefined(screen.panel_location) && screen.panel_location === "right" && appHelper.isDefined(screen.assets.left);
}
export function showAssetLeft(screen) {
    return appHelper.isDefined(screen.assets.left);
}

export function showAssetRightPanel(screen) {
    return appHelper.isDefined(screen.panel_location) && screen.panel_location === "left" && appHelper.isDefined(screen.assets.right);
}

export function showAssetRight(screen) {
    return appHelper.isDefined(screen.assets.right);
}

export function checkImageWidth(screen) {
    let width = {
        styles: {}
    };
    if (showAssetLeftPanel(screen) || showAssetRightPanel(screen)) {

        width = checkAssetPanelImageWidth(screen.screen_id, screen);
    }else if (showAssetLeft(screen) || showAssetRight(screen)) {

        width = checkContentImageWidth(screen.screen_id, screen);
    }
    return width;
}
export function getAssetType(asset) {
    let returnAsset = {};
    if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
        let screenCharacter = appHelper.getCharacterAsset(asset);
        returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
    } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
        returnAsset = appHelper.getIconAsset(asset);
    } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
        returnAsset = appHelper.getImageAsset(asset);
    } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
        returnAsset = appHelper.getLibraryImageAsset(asset);
    }

    returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

    return returnAsset;
}
export function checkAssetPanelImageWidth(screen_id, screen) {
    let contentArea = document.getElementById(`screenWrapper`);
    let max = Math.round((contentArea.offsetWidth / 100) * 40 ) - 20;
    let width = 0;
    //console.log('width set at line 60', width);
    if (showAssetLeftPanel(screen) || showAssetRightPanel(screen)) {
        let screenAsset = {};
        if (showAssetLeftPanel(screen)) {
            screenAsset = getAssetType(screen.assets.left);
        } else if (showAssetRightPanel(screen)) {
            screenAsset = getAssetType(screen.assets.right);
        }

        if (appHelper.isDefined(screenAsset.width)) {
            let obj = appHelper.getArrayObjectByKey(objectModels.SPECIIFIC_IMAGE_SIZES,"constant",screen.screen_image_width);
            switch (screen.image_size) {
                case objectConstants.IMAGE_SIZE_ACTUAL:
                    width = screenAsset.width < max ? screenAsset.width : max;
                    //console.log('width set at line 74', width);
                    break;
                case objectConstants.IMAGE_SIZE_RETINA:
                    width = (screenAsset.width / 2) < max ? (screenAsset.width / 2) : max;
                    //console.log('width set at line 78', width);
                    break;
                case objectConstants.IMAGE_SIZE_SPECIFIC:
                    width = Math.round((contentArea.offsetWidth / 100) * obj.value );
                    //console.log('width set at line 83', width);
                    break;
                case objectConstants.IMAGE_SIZE_MAX:
                    width = max;
                    //console.log('width set at line 86', width);
                    break;
            }


            if(getImageShape(screen_id, screen).length > 0 && screenAsset.width > 0){
                if(screen.image_shape === objectConstants.IMAGE_SHAPE_RECTANGLE) {
                    let imageOrientation = getImageOrientation(screen_id, screen);
                    if(imageOrientation === "landscape") {
                        let maxWidth = (screenAsset.width / 100) * 58.5 ;
                        if (width > maxWidth) {
                            width = maxWidth;
                            //console.log('width set at line 98', width);

                        }
                    }else{
                        if (screenAsset.width < width) {
                            width = screenAsset.width;
                            //console.log('width set at line 104', width);

                        }
                    }
                }else{
                    if (screenAsset.height < width) {
                        width = screenAsset.height;
                        //console.log('width set at line 111', width);

                        if (screenAsset.width < width) {
                            width = screenAsset.width;
                            //console.log('width set at line 115', width);
                        }
                    } else if (screenAsset.width < width) {
                        width = screenAsset.width;
                        //console.log('width set at line 119', width);
                        if (screenAsset.height < width) {
                            width = screenAsset.height;
                            //console.log('width set at line 122', width);
                        }
                    }
                }
            }else{
                if(screenAsset.width < width && screenAsset.width > 0){
                    width = screenAsset.width;
                    //console.log('width set at line 129', width);
                }
            }
        }
    }

    //console.log(`width: `,width);
    return {
        styles: {
            width: width,
            display: width === 0 ? 'none' : 'block'
        }
    };
}

export function checkContentImageWidth(screen_id, screen) {
    let contentArea = document.getElementById(`${screen.screen_id}_feed_id`);

    let width = 0;
    if (showAssetLeft(screen) || showAssetRight(screen)) {
        let screenAsset = {};
        if (showAssetLeft(screen)) {
            screenAsset = getAssetType(screen.assets.left);
        } else if (showAssetRight(screen)) {
            screenAsset = getAssetType(screen.assets.right);
        }

        if (appHelper.isDefined(screenAsset.width) && contentArea !== null) {
            let max = Math.round((contentArea.offsetWidth / 100) * 40 );
            let obj = appHelper.getArrayObjectByKey(objectModels.SPECIIFIC_IMAGE_SIZES,"constant",screen.screen_image_width);
            switch (screen.image_size) {
                case objectConstants.IMAGE_SIZE_ACTUAL:
                    width = screenAsset.width < max ? screenAsset.width : max;
                    break;
                case objectConstants.IMAGE_SIZE_RETINA:
                    width = (screenAsset.width / 2) < max ? (screenAsset.width / 2) : max;
                    break;
                case objectConstants.IMAGE_SIZE_SPECIFIC:
                    width = Math.round((contentArea.offsetWidth / 100) * obj.value );
                    break;
                case objectConstants.IMAGE_SIZE_MAX:
                    width = max;
                    break;
            }

            if(getImageShape(screen_id, screen).length > 0 && screenAsset.width > 0){
                if(screen.image_shape === objectConstants.IMAGE_SHAPE_RECTANGLE) {
                    let imageOrientation = getImageOrientation(screen_id, screen);
                    if(imageOrientation === "landscape") {
                        let maxWidth = (screenAsset.width / 100) * 58.5 ;
                        if (width > maxWidth) {
                            width = maxWidth;
                        }
                    }else{
                        if (screenAsset.width < width) {
                            width = screenAsset.width;
                        }
                    }
                }else {
                    if (screenAsset.height < width) {
                        width = screenAsset.height;
                        if (screenAsset.width < width) {
                            width = screenAsset.width;

                        }
                    } else if (screenAsset.width < width) {
                        width = screenAsset.width;
                        if (screenAsset.height < width) {
                            width = screenAsset.height;
                        }
                    }
                }
            }else{
                if(screenAsset.width < width && screenAsset.width > 0){
                    width = screenAsset.width;
                }
            }
        }
    }

    return {
        styles: {
            width: width,
            display: width === 0 ? 'none' : 'block'
        }
    };
}



export function getAssetLeftPanelId(screen_id) {
    return `${screen_id}${objectConstants.ASSET_LEFT_PANEL_POSTFIX}`;

}

export function getAssetRightPanelId(screen_id) {
    return `${screen_id}${objectConstants.ASSET_RIGHT_PANEL_POSTFIX}`;
}

export function getAssetLeftId(screen_id) {
    return `${screen_id}${objectConstants.ASSET_LEFT_POSTFIX}`;

}

export function getAssetRightId(screen_id) {
    return `${screen_id}${objectConstants.ASSET_RIGHT_POSTFIX}`;
}

export function getContentAreaId(screen_id) {
    return `${screen_id}${objectConstants.CONTENT_AREA_POSTFIX}`;
}


export function getImageClass(screen){
    let imageShape = getImageShape(screen.screen_id, screen);
    let imageEffect = getImageEffect(screen);
    let imageOrientation = getImageOrientation(screen.screen_id, screen);
    return `${imageShape} ${imageEffect} ${imageOrientation}`;
}

export function getImageShape(screen_id, screen){
    //image_shape
    let imageOrientation = getImageOrientation(screen_id, screen);

    if(screen.image_shape !== NONE){
        if(imageOrientation === "landscape"){
            return `${screen.image_shape} ${screen.image_mask_position_landscape}`;
        }else{
            return `${screen.image_shape} ${screen.image_mask_position_portrait}`;
        }
    }
    else{
        return "none";
    }


}

export function getImageEffect(screen){
    //image_effect
    return screen.image_effect !== NONE ?  screen.image_effect : "none";
}

export function getImageOrientation(screen_id, screen){
    let screenAsset = {};
    if (showAssetLeftPanel(screen)) {
        screenAsset = getAssetType(screen.assets.left);
    } else if (showAssetRightPanel(screen)) {
        screenAsset = getAssetType(screen.assets.right);
    }else if (showAssetLeft(screen)) {
        screenAsset = getAssetType(screen.assets.left);
    }else if (showAssetRight(screen)) {
        screenAsset = getAssetType(screen.assets.right);
    }


    if (appHelper.isDefined(screenAsset)) {
        return screenAsset.width < screenAsset.height ? "portrait" : "landscape";
    }

    return "";
}


// Objects
export function getAssetImageOrientation(asset){
    let image = {};
    if(appHelper.isDefined(asset.left)){
        image = Object.assign({},asset.left);
    }else if(appHelper.isDefined(asset.right)){
        image = Object.assign({},asset.right);
    }else if(appHelper.isDefined(asset.top)){
        image = Object.assign({},asset.top);
    }else if(appHelper.isDefined(asset.bottom)){
        image = Object.assign({},asset.bottom);
    }else if(appHelper.isDefined(asset.image)){
        image = Object.assign({},asset.image);
    }

    if(appHelper.isDefined(image.width) && appHelper.isDefined(image.height)){
        return image.width < image.height ? "portrait" : "landscape";
    }
    return "landscape";
}

export function getAssetImageShape(asset){

    //image_shape
    let imageOrientation = getAssetImageOrientation(asset);

    if(asset.image_shape !== NONE){
        if(imageOrientation === "landscape"){
            return `${asset.image_shape} ${asset.image_mask_position_landscape}`;
        }else{
            return `${asset.image_shape} ${asset.image_mask_position_portrait}`;
        }
    }
    else{
        return "none";
    }
}

export function getAssetImageClass(asset){
    let imageShape = getAssetImageShape(asset);
    let imageEffect = getImageEffect(asset);
    let imageOrientation = getAssetImageOrientation(asset);
    return `${imageShape} ${imageEffect} ${imageOrientation}`;
}

export function checkAssetImageWidth(asset, image, maxWidth) {
    if (appHelper.isDefined(asset.top) || appHelper.isDefined(asset.right) || appHelper.isDefined(asset.bottom) || appHelper.isDefined(asset.left) || appHelper.isDefined(asset.image)) {
        //console.log(`maxWidth`, maxWidth ,`image`, image);
        let max = maxWidth;
        if (appHelper.isDefined(asset.left) || appHelper.isDefined(asset.right)){
            max = Math.round((maxWidth / 100) * 40 ) - 20;
        }

        let width = max;
        let validationMsg = "Your image has reached it's maximum width";
        let showValidation = false;


        /*let image = {};
        if(appHelper.isDefined(asset.left)){
            image = Object.assign({},asset.left);
        }else if(appHelper.isDefined(asset.right)){
            image = Object.assign({},asset.right);
        }else if(appHelper.isDefined(asset.top)){
            image = Object.assign({},asset.top);
        }else if(appHelper.isDefined(asset.bottom)){
            image = Object.assign({},asset.bottom);
        }else if(appHelper.isDefined(asset.image)){
            image = Object.assign({},asset.image);
            //console.log(`image`,image);
        }*/

        if(image.constant === "icon" && (!appHelper.isDefined(image.width) || image.width === null || image.width === "" )){
            image = Object.assign({},image,{
                width: 500,
                height: 500,
            });
        }

        if (appHelper.isDefined(image.width)) {
            let imageWidth = parseInt(image.width);
            let imageHeight = parseInt(image.height);
            let obj={};
            if(appHelper.isDefined(asset.left) || appHelper.isDefined(asset.right)){
                obj = appHelper.getArrayObjectByKey(objectModels.ASSET_IMAGE_SIZES, "constant", asset.asset_image_width);
            }else if(appHelper.isDefined(asset.top) || appHelper.isDefined(asset.bottom) ){
                obj = appHelper.getArrayObjectByKey(objectModels.TOP_ASSET_IMAGE_SIZES,"constant",asset.top_asset_image_width);
            }else if(appHelper.isDefined(asset.image)){
                obj = appHelper.getArrayObjectByKey(objectModels.TOP_ASSET_IMAGE_SIZES,"constant",asset.asset_image_width);
            }
            switch (asset.image_size) {
                case objectConstants.IMAGE_SIZE_ACTUAL:
                    width = imageWidth < width && imageWidth > 0  ? imageWidth : width;
                    break;
                case objectConstants.IMAGE_SIZE_RETINA:
                    width = (imageWidth / 2) <  width && imageWidth > 0 ? (imageWidth / 2) : width;
                    break;
                case objectConstants.IMAGE_SIZE_SPECIFIC:

                    width = Math.round((maxWidth / 100) * obj.value);
                    break;
                case objectConstants.IMAGE_SIZE_MAX:
                    width = imageWidth < width && imageWidth > 0  ? imageWidth : width;
                    break;
            }

            if(getAssetImageShape(asset).length > 0 && imageWidth > 0){
                if(asset.image_shape === objectConstants.IMAGE_SHAPE_RECTANGLE) {
                    let imageOrientation = getAssetImageOrientation(asset);
                    if(imageOrientation === "landscape") {
                        let maxWidth = (imageWidth / 100) * 58.5 ;


                        if (width > maxWidth) {
                            width = maxWidth;
                        }

                        let maxHeight  =  (width / 3) * 4;
                        if(maxHeight > imageHeight){
                            let maxWidth = (imageHeight / 3) * 2.2 ;
                            width = maxWidth;
                        }
                    }else{
                        if (imageWidth < width) {
                            width = imageWidth;
                        }
                    }
                }else if(asset.image_shape !== NONE){
                    // console.log(`asset.image_shape`,asset.image_shape)
                    if (imageHeight < width) {
                        width = imageHeight;

                        if (imageWidth < width) {
                            width = imageWidth;

                        }
                    } else if (imageWidth < width) {
                        width = imageWidth;

                        if (imageHeight < width) {
                            // console.log('hello2')
                            width = imageHeight;

                        }
                    }
                }


            }else{
                if(imageWidth < width && imageWidth > 0){
                    width = imageWidth;
                }
            }
        }

        return {
            styles: {
                width: width
            },
            validation:{
                message: showValidation ? validationMsg : ""
            }
        };

    }
    return {
        styles: {},
        validation:{}
    };
}



/** WEBPACK FOOTER **
 ** ./src/helpers/imageHelper.js
 **/